module.exports = __webpack_public_path__ + "static/media/play.db9b21a1.png";